//import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Box, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { concat, get } from 'lodash';
import React, { FC, useMemo } from 'react';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { APIS } from '../../../../../../../lib/constants/apis';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, KOSTEN_ARTEN, KOSTEN_POSITION, PRUEF_ASSISTENZ_STATUS } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { ForceTrue, GetVNEigenmittelValidation } from '../../../../../../../lib/validation/ValidationTypes';
import { addIndexesToPath, isTrue } from '../../../../../../../utils/helper';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import { ZahlenMaesigeNachweisBerichtFinanzierung, ZahlenMaesigeNachweisBerichtInvest } from '../finanzierung-plan/ZahlenMaessigeNachweisBericht';

// import schemas
import KostenPositionSchema from '../../../../../../../lib/paths/kostenposition_FULL_Paths.json';
import NachweisPositionSchema from '../../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsnachweisSchema.attributes;
const KP_P = KostenPositionSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const EigenmittelVNLIS: FC<{ kostentraeger: string; unternehmenId: number }> = ({ kostentraeger, unternehmenId }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const isSelectedNachweisReadOnly = (nachweisObj: any) => {
		if (get(nachweisObj, NP_P.Pruefung_Pruefstatus.path) === PRUEF_ASSISTENZ_STATUS.freigegeben) {
			return true;
		} else {
			return readOnly;
		}
	};

	// Berechnung der Gesamt Eigenmittel aus dem Antrag
	const gesamtSOLLEinnahmenSumme = useMemo(() => {
		return get(application, VN_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Einnahme)
			.reduce((sum: any, item: any) => {
				const kosten = get(item, KP_P.Allgemein_Geplante_Gesamtsumme.path, 0);
				// Stelle sicher, dass es eine Zahl ist
				const kostenNumber = typeof kosten === 'number' ? kosten : parseFloat(kosten) || 0;
				return sum + kostenNumber;
			}, 0);
	}, [application]);

	//  Gesamt Ausgaben aus dem Verwendungsnachweis
	// const gesamtAusgabenSumme = useMemo(() => {
	// 	return get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, [])
	// 		.filter((ele: any) => get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Ausgabe)
	// 		.reduce((sum: any, item: any) => {
	// 			const kosten = get(item, NP_P.Allgemein_Ausgaben_Kosten.path, 0);
	// 			// Stelle sicher, dass es eine Zahl ist
	// 			const kostenNumber = typeof kosten === 'number' ? kosten : parseFloat(kosten) || 0;
	// 			return sum + kostenNumber;
	// 		}, 0);
	// }, [application]);

	// Gesamt Eigenmittel aus dem Verwendungsnachweis
	const gesamtEinnahmenSumme = useMemo(() => {
		return get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, [])
			.filter((ele: any) => get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Einnahme)
			.reduce((sum: any, item: any) => {
				const kosten = get(item, NP_P.Allgemein_Ausgaben_Kosten.path, 0);
				// Stelle sicher, dass es eine Zahl ist
				const kostenNumber = typeof kosten === 'number' ? kosten : parseFloat(kosten) || 0;
				return sum + kostenNumber;
			}, 0);
	}, [application]);

	// Zuwendungsanteil aus dem Verwendungsnachweis
	// Das wird durch Formel berechnet
	const istZuwendungAnteil = useMemo(() => {
		return get(application, VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path, '0');
	}, [application]);

	// Summe der Ist Finanzierung = Ist Zuwendungsanteil + Ist Eigenmittel
	const istSummeFinanzierung = useMemo(() => {
		return parseFloat(istZuwendungAnteil) + parseFloat(gesamtEinnahmenSumme);
	}, [istZuwendungAnteil, gesamtEinnahmenSumme]);

	// Hier muss Fehler angezeigt werden, wenn die Summe der Ausgaben ungleich der Ist Finanzierung ist
	// const showError = useMemo(() => {
	// 	return parseFloat(gesamtAusgabenSumme) === istSummeFinanzierung ? false : true;
	// }, [gesamtAusgabenSumme, istSummeFinanzierung]);

	return (
		<>
			<ApplicationHeading title='Verwendungsnachweis' />

			<Typography variant='h6' gutterBottom sx={{ mb: '1rem' }}>
				Zahlenmäßiger Nachweis der Finanzierung des Vorhabens
			</Typography>
			<ZahlenMaesigeNachweisBerichtInvest />

			{/* eslint-disable-next-line array-callback-return */}
			{get(application, VN_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).map((eachKostenPosition: any, i: number) => {
				if (
					get(eachKostenPosition, KP_P.Allgemein_Kostentraeger.path) === kostentraeger &&
					get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel &&
					get(eachKostenPosition, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					return (
						<React.Fragment key={i}>
							{/* eslint-disable-next-line array-callback-return */}
							{get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []).map((eachNachweis: any, nachweisIndex: number) => {
								if (get(eachNachweis, `${NP_P.Allgemein_Kostenposition.path}.id`) === get(eachKostenPosition, 'id')) {
									return (
										<React.Fragment key={nachweisIndex}>
											<PruefAssistenz
												statusPath={addIndexesToPath(
													VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Pruefstatus.path,
													[`${nachweisIndex}`],
													['Verwendungsnachweis_Nachweispositions']
												)}
												hinweisPath={addIndexesToPath(
													VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
													[`${nachweisIndex}`],
													['Verwendungsnachweis_Nachweispositions']
												)}
												ueberarbeitetAmPath={addIndexesToPath(
													VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
													[`${nachweisIndex}`],
													['Verwendungsnachweis_Nachweispositions']
												)}
												erledigtPath={addIndexesToPath(
													VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Erledigt.path,
													[`${nachweisIndex}`],
													['Verwendungsnachweis_Nachweispositions']
												)}
												formStruc={mapFormStruc(PruefAssistenzStruc(), nachweisIndex)}
											/>

											<Box sx={{ border: '5px solid ', borderColor: 'secondary.main', p: '2rem 0.5rem 2rem 2rem', mt: 4, mb: 2 }}>
												<Grid2 container spacing={6}>
													<Grid2 sm={6}>
														<>
															<Typography sx={{ fontWeight: 'bold' }}>
																Bitte berücksichtigen Sie bei der Angabe der Eigen- und Drittmittel:
															</Typography>
															<Typography>
																Ausgaben können nur bis zur im Förderbescheid festgesetzen Ausgabenhöhe als zuwendungsfähis anerkannt
																werden. Mögliche Mehrausgaben gehen zu Lasten des Zuwendungsemfängers.
															</Typography>
														</>
													</Grid2>
													<Grid2 sm={6}>
														<CreateForm
															formStruc={mapFormStruc(formStrucNachweis(), nachweisIndex)}
															formValues={application}
															updateFormValuesFunc={setApplicationProperty}
															readOnly={isSelectedNachweisReadOnly(eachNachweis)}
															api={APIS.Nachweisposition}
														/>
													</Grid2>
												</Grid2>
											</Box>
										</React.Fragment>
									);
								}
							})}
						</React.Fragment>
					);
				}
			})}
			<Box sx={{ mt: '2rem' }}>
				<ZahlenMaesigeNachweisBerichtFinanzierung
					sollEigenmittel={gesamtSOLLEinnahmenSumme}
					isSummeEigenmittel={gesamtEinnahmenSumme}
					isSummeFinanzierung={istSummeFinanzierung}
				/>
			</Box>
		</>
	);
};
export default EigenmittelVNLIS;

const PruefAssistenzStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucNachweis = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					label: 'Eigen-/Drittmittel',
					format: 'currency',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStrucValidation = (application: any) => {
	const allNachweisPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

	const summeAusgabe = allNachweisPositions
		.filter((ele: any) => get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Ausgabe)
		.reduce((sum: any, item: any) => {
			const kosten = get(item, NP_P.Allgemein_Ausgaben_Kosten.path, 0);
			// Stelle sicher, dass es eine Zahl ist
			const kostenNumber = typeof kosten === 'number' ? kosten : parseFloat(kosten) || 0;
			return sum + kostenNumber;
		}, 0);

	const summeEigenmittel = allNachweisPositions
		.filter((ele: any) => get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Einnahme)
		.reduce((sum: any, item: any) => {
			const kosten = get(item, NP_P.Allgemein_Ausgaben_Kosten.path, 0);
			// Stelle sicher, dass es eine Zahl ist
			const kostenNumber = typeof kosten === 'number' ? kosten : parseFloat(kosten) || 0;
			return sum + kostenNumber;
		}, 0);

	const bewilligteFoerderQuote = get(application, VN_P.Foerderantrag.schema.attributes.Bewilligung_Foerderquote_Gesamt.path, 0);

	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					validation: [
						{
							validateFunction: GetVNEigenmittelValidation,
							params: [summeAusgabe, summeEigenmittel, bewilligteFoerderQuote],
							disabledValidation: false,
						},
					],
				},
			],
		},
	];
	return struc;
};

const mapFormStruc = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, VN_P.Verwendungsnachweis_Nachweispositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(VN_P.Verwendungsnachweis_Nachweispositions.path.length),
				};
			}),
		};
	});
	return result;
};
export const getFormStrucEigenmittelVNLIS = (application: any, kostentraeger: string, unternehmenId: number, _readOnly: boolean) => {
	let result: FormStrucItem[] = [];
	get(application, VN_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).forEach((eachKostenPosition: any) => {
		if (
			get(eachKostenPosition, KP_P.Allgemein_Kostentraeger.path) === kostentraeger &&
			get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel &&
			get(eachKostenPosition, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const allNachweisPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

			allNachweisPositions.forEach((eachNachweis: any, nachweisIndex: number) => {
				if (get(eachNachweis, `${NP_P.Allgemein_Kostenposition.path}.id`) === get(eachKostenPosition, 'id')) {
					const isHinweisFieldRequired =
						get(eachNachweis, NP_P.Pruefung_Hinweis_Fuer_Den_Antragsteller.path) && !isTrue(get(eachNachweis, NP_P.Pruefung_Erledigt.path));

					const PruefAssistenzStrucWithIndex = mapFormStruc(PruefAssistenzStruc(), nachweisIndex);

					const customFormStrucValidationWithIndex = mapFormStruc(customFormStrucValidation(application), nachweisIndex);

					if (isHinweisFieldRequired) result = concat(result, PruefAssistenzStrucWithIndex, customFormStrucValidationWithIndex);
					else result = concat(result, customFormStrucValidationWithIndex);
				}
			});
		}
	});
	return result;
};
